import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CommonStreamOpenButton from "ui/common/stream/StreamOpenButton";

class StreamOpenButton extends React.Component {

	isVideoCallAvailable() {
		return !this.props.channel.locked &&
			this.props.channel.online &&
			!this.props.channel.readOnly &&
			this.props.configuration.interface.streams.video.calls.enabled &&
			this.props.configuration.interface.channel.directEnabled &&
			!this.props.stream
	}

	render() {
		if (!this.isVideoCallAvailable()) {
			return null;
		}

		return <CommonStreamOpenButton label={ this.props.i18n.makeVideoCall ? this.props.i18n.makeVideoCall : '' } type="stream.video.twilio.room.go" parameters={ { channel: { id: this.props.channel.id } } } />;
	}
}

StreamOpenButton.propTypes = {
	channel: PropTypes.object.isRequired
};

export default connect(
	(state, ownProps) => ({
		configuration: state.configuration,
		i18n: state.application.i18n,
		stream: state.ui.streams.find( stream => stream.channel && stream.channel.id === ownProps.channel.id )
	})
)(StreamOpenButton);